import styled from "styled-components";
import {ConstBorderRound, ConstBreakPoint, ConstColor, ConstWidth} from "../../../../config/styles_const/styles_const";
import HeadlineLarge from "../../../common/atom/text/headline_large";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";

// Todo: calcで使う値の定数化
export const AuthWrapper = styled(PageWrapper)`
    padding-top: 30px;
    min-height: calc(100vh - 130px); // headerの高さ + AuthWrapperの上下のpadding = 130px
    max-width: 100%;
    background-color: ${ConstColor.DeepBlack};
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        padding-top: 50px;
        min-height: calc(100vh - 150px); // headerの高さ + AuthWrapperの上下のpadding = 150px
    }
`;

export const LoginFormWrapper = styled.div`
    background-color: ${ConstColor.White};
    border-radius: ${ConstBorderRound.AuthBorder};
    max-width: 380px;
    padding: 20px;
    margin: 0 auto;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        padding: 40px;
    }    
`;

export const CreateFormWrapper = styled(LoginFormWrapper)`
    max-width: ${ConstWidth.ContentsMaxWidth};
`;

export const AuthFormTitle = styled(HeadlineLarge)`
    text-align: center;
    margin-bottom: 30px;
`;

export const AuthFormImg = styled.img`
    margin-bottom: 30px;
`;

export const CreateFormFlex = styled.div`
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        display: flex;
        justify-content: space-between;
    }
`;


// WEBPACK FOOTER //
// ./src/presentation/component/auth/share/auth_share_components.tsx